module.exports = __webpack_public_path__ + "static/media/Chat.844bf7dc.svg";